import React, { Component, useEffect } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Provider } from 'react-redux';
import { useClearCacheCtx } from 'react-clear-cache';

import store from './store';

import './App.scss';
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import './scss/style.scss';
// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404, Page500, AlterarPwd } from './views/Pages';
// Viewers
const loading = () => (
  <div className="animated fadeIn pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const App = () => {
  const { isLatestVersion, emptyCacheStorage } = useClearCacheCtx();

  useEffect(() => {
    window.onhashchange = function () {
      const helper = require('./util/helper.js');
      if (!helper.validJWTCorporate()) {
        toast.error('Sua sessão expirou, faça login novamente.', 2000);

        setTimeout(() => {
          window.location.href = `#/login`;
        }, 2000);
      }
    };

    if (!isLatestVersion) {
      emptyCacheStorage();
    }
  }, [isLatestVersion, emptyCacheStorage]);
  // useEffect(() => {
  //   setTimeout(() => {
  //     localStorage.removeItem("nome")
  //     localStorage.removeItem("numeroDoContrato")
  //     localStorage.removeItem("cpfCnpj")
  //     localStorage.removeItem("dataBaseInicial")
  //     localStorage.removeItem("dataBaseFim")
  //     localStorage.removeItem("situacao")
  //   }, 100 * 10 * 10 /* 10 minutos */)
  // }, [])
  return (
    <Provider store={store}>
      <HashRouter>
        <React.Suspense fallback={loading()}>
          <Switch>
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route
              exact
              path="/alterarpwd"
              name="AlterarPwd Page"
              component={AlterarPwd}
            />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            <Route path="/" name="Home" component={DefaultLayout} />
            <Route exact path="/" name="Login Page" component={DefaultLayout} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    </Provider>
  );
};

// class App extends Component {
//   componentWillMount() {
//     window.onhashchange = function () {
//       const helper = require('./util/helper.js');
//       if (!helper.validJWTCorporate()) {
//         toast.error('Sua sessão expirou, faça login novamente.', 2000);

//         setTimeout(() => {
//           window.location.href = `#/login`;
//         }, 2000);
//       }
//     };

//   }

//   render() {
//     return (
//       <Provider store={store}>
//         <HashRouter>
//           <React.Suspense fallback={loading()}>
//             <Switch>
//               <Route exact path="/login" name="Login Page" component={Login} />
//               <Route
//                 exact
//                 path="/alterarpwd"
//                 name="AlterarPwd Page"
//                 component={AlterarPwd}
//               />
//               <Route exact path="/404" name="Page 404" component={Page404} />
//               <Route exact path="/500" name="Page 500" component={Page500} />
//               <Route path="/" name="Home" component={DefaultLayout} />
//               <Route
//                 exact
//                 path="/"
//                 name="Login Page"
//                 component={DefaultLayout}
//               />
//             </Switch>
//           </React.Suspense>
//         </HashRouter>
//       </Provider>
//     );
//   }
// }

export default App;
